<template>
  <section class="toasty">
    <transition-group name="message" tag="ul">
      <toast :toast="toast" :remove="remove" :key="toast._id" v-for="toast in toasts" />
    </transition-group>
  </section>
</template>

<style lang="scss" scoped>
.toasty {
  position: fixed;
  z-index: 1000;
  right: 16px;
  bottom: 16px;
  width: 300px;
  padding: 16px;
  display: flex;
  flex-direction: column-reverse;
  pointer-events: none;

  .toast {
    transition: all 0.3s ease-out;
    display: inline-block;
    margin-right: 10px;
    width: 100%;
    pointer-events: all;

    &.message-enter,
    &.message-leave-to,
    &.message-leave-active {
      opacity: 0;
      transform: translateX(100%);
    }
  }
}
</style>

<script>
// @flow
import Toast from './Toast'
import uuid from 'uuid'
export default {
  name: 'toasty',
  components: { Toast },
  data: () => {
    return {
      toasts: []
    }
  },
  methods: {
    add(toast: { type: string, header: ?string, text: ?string, remove: ?number }): string {
      const toastId = `toast-${uuid.v4()}` // NB: id must start with a letter
      this.toasts.push({ ...toast, _id: toastId })

      if (toast.remove) setTimeout(() => this.remove(toastId), toast.remove + 500) // NB: count in animation times ~500

      return toastId
    },

    remove(toastId) {
      this.toasts = this.toasts.filter(t => t._id !== toastId)
    },

    removeAll() {
      this.toasts = []
    }
  }
}
</script>
